export const generateTimeOptions = (selectedStartTime?: string): string[] => {
  const times: string[] = [];
  const interval = 30; // 30 minutes interval

  for (let hours = 0; hours < 24; hours++) {
    for (let minutes = 0; minutes < 60; minutes += interval) {
      const hour = hours.toString().padStart(2, '0');
      const minute = minutes.toString().padStart(2, '0');
      times.push(`${hour}:${minute}`);
    }
  }

  if (selectedStartTime) {
    const startIndex = times.indexOf(selectedStartTime);
    if (startIndex !== -1) {
      // Filter times to only show times at least 1 hour after start time
      const minEndIndex = startIndex + 2; // +2 because each slot is 30 mins
      return times.slice(minEndIndex);
    }
  }

  return times;
};

export const addOneHourToTime = (time: string): string => {
  const [hours, minutes] = time.split(':').map(Number);
  const totalMinutes = hours * 60 + minutes + 60;
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;
  return `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
};

export const convertTo12HourFormat = (time: string): string => {
  const [hours, minutes] = time.split(':').map(Number);
  const period = hours >= 12 ? 'pm' : 'am';
  const adjustedHours = hours % 12 || 12;
  return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
};

export const convertTo24HourFormat = (time: string) => {
  const [timePart, period] = time.split(' ');
  let [hour, minute] = timePart.split(':');
  hour = period.toLowerCase() === 'pm' && hour !== '12' ? (parseInt(hour) + 12).toString() : hour;
  hour =
    period.toLowerCase() === 'am' && hour === '12' ? '00' : parseInt(hour) < 10 ? '0' + hour : hour;
  return `${hour}:${minute}`;
};
